import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { FormAlertType } from '../../../core/constants/constants';

//because the alerts in forms are different than the general notify alerts according to UX
//choose this component over the cl-error-alert as that one is deprecated

@Component({
  selector: 'form-alert',
  templateUrl: './form-alert.component.html',
  styleUrls: ['./form-alert.component.scss']
})

export class FormAlertComponent implements OnInit, OnChanges {
  @Input() alertMessage: string;
  @Input() externalStyles: any = {};
  @Input() id: string = 'theAlert';
  @Input() type: FormAlertType = FormAlertType.ERROR;
  @Input() preventClosing: boolean = true;

  customStyle: string = 'alert-custom-error';
  showAlert = true;

  constructor(
    public translateSvc: TranslateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'error',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../assets/images/caution_circ_solid_dark.svg")
    );
    this.matIconRegistry.addSvgIcon(
      'warning',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../assets/images/caution_outline.svg")
    );
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitizer.bypassSecurityTrustResourceUrl("../../../../assets/images/select-checkmark.svg")
    );
  }

  ngOnInit() {
    this.updateAlertStyleBasedOnType();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.type && changes.type.currentValue) {
      this.type = changes.type.currentValue;
      this.updateAlertStyleBasedOnType();
    }
  }

  updateAlertStyleBasedOnType() {
    if (this.type == FormAlertType.ERROR)
      this.customStyle = 'alert-custom-error';
    else if (this.type == FormAlertType.WARNING)
      this.customStyle = 'alert-custom-warning';
    else
      this.customStyle = 'alert-custom-success';
  }

  closeAlert() {
    this.showAlert = false;
  }
}